import * as React from 'react'
import { FC } from 'react'


import './Arrow.scss'

const ArrowDown: FC = () => {
    return (
        <svg className="Arrow Arrow--down" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 31.7">
            <path fill="#fff" d="M.9 31.7l-.9-1 15.2-14.9L0 .9.9 0 17 15.8z" />
        </svg>
    )
}

export default ArrowDown
